import { root, id } from './cancel-trial';

export const cancelTrial = {
  ...root,
  id: id,
};
